// extracted by mini-css-extract-plugin
export var createdDate = "_h3-1";
export var divider = "_h3-2";
export var headerDivider = "_h3-3";
export var messagesCard = "_h3-0";
export var messagesContainer = "_h3-6";
export var messagesContainerWrapper = "_h3-4";
export var showLeftPanelButton = "_h3-8";
export var topButtons = "_h3-7";
export var withPadding = "_h3-5";